import { AdsMccCheckCard } from '@/components/clients/AdsMccCheckCard';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Empty state for a Google Ads page when the selected client has no Google Ads
 * account linked. Nothing here can change anything: no link, no button, no
 * pointer to Settings, and no MCC id of its own. The embedded MCC check card
 * hides itself when the check is switched off, which leaves just this message.
 */
export function NoGoogleAdsAccountState({
  tenantId,
  sectionTitle,
}: {
  tenantId: string;
  sectionTitle: string;
}) {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>No Google Ads account linked yet</CardTitle>
          <CardDescription>
            <span className="font-medium text-foreground">{tenantId}</span> has no Google Ads
            account linked, so {sectionTitle} can&apos;t load.
          </CardDescription>
        </CardHeader>
      </Card>
      <AdsMccCheckCard variant="embedded" />
    </div>
  );
}
